import { render, staticRenderFns } from "./EditSectorModal.vue?vue&type=template&id=191ca098&scoped=true&lang=pug&"
import script from "./EditSectorModal.vue?vue&type=script&lang=js&"
export * from "./EditSectorModal.vue?vue&type=script&lang=js&"
import style0 from "./EditSectorModal.vue?vue&type=style&index=0&id=191ca098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191ca098",
  null
  
)

export default component.exports